import brands from '@/brands.json'
import { handleResize } from '@utils/therapy'

const setStatus = (state, item, status) => {
  if (status === undefined) {
    state[item] = !state[item]
  } else {
    state[item] = status
  }
}
const app = {
  state: {
    brand: brands[process.env.VUE_APP_CUR_BRAND],
    isStage: false,
    leftPanel: true,
    isFullScreen: false,
    rightPanel: false,
    header: true,
    canvasWidth: '',
    canvasHeight: '',
    listDialogVisible: false,
    listDialogType: 'all',
    overDialogVisible: false,
    message: {
      visible: false,
      message: '',
      title: '',
      onConfirm: _ => _,
      onClose: _ => _,
    },
  },
  mutations: {
    // 设置 消息框 信息
    setMsgBox: (state, msg) => {
      state.message.title = msg.title
      state.message.visible = msg.visible
      state.message.message = msg.message
      state.message.onConfirm = msg.onConfirm
      state.message.onClose = msg.onClose
    },
    // 设置是否 显示 训练结束提示框
    showTherapyOverMsgBox: (state, status) => {
      setStatus(state, 'overDialogVisible', status)
    },
    // 设置是否 显示 消息框
    showMsgBox: (state, status) => {
      state.message.visible = status
    },
    // 设置 舞台 状态 (显示/不显示)
    setAppStatus: (state, status) => {
      state.isStage = status
    },
    // 设置是否全屏
    setScreenStatus: (state, status) => {
      setStatus(state, 'isFullScreen', status)
    },
    // 设置 训练列表 状态 (显示/不显示)
    setTherapyListDialog: (state, status) => {
      setStatus(state, 'listDialogVisible', status)
    },
    // 设置 训练列表 类型
    setListDialogType: (state, type) => {
      state.listDialogType = type
    },
    // 设置 左边栏 状态 (显示/不显示)
    setLeftPannelStatus: (state, status) => {
      setStatus(state, 'leftPanel', status)
    },
    // 设置 右边栏 状态 (显示/不显示)
    setRightPannelStatus: (state, status) => {
      setStatus(state, 'rightPanel', status)
    },
    setHeader: (state, status) => {
      state.header = status
    },
    // 设置 训练画布 大小 (适应舞台、场景)
    setScenceSize: state => {
      if (state.isFullScreen === false) {
        setTimeout(() => handleResize(), 250)
      } else {
        $('#therapy-canvas').css({ width: '100vw', height: '100vh' })
      }
    },
  },
  actions: {
    SetLeftPanelStatus({ commit }, status) {
      commit('setLeftPannelStatus', status)
      commit('setScenceSize')
    },
    SetRightPannelStatus({ commit }, status) {
      commit('setRightPannelStatus', status)
      commit('setScenceSize')
    },
  },
}

export default app
